export const formatSummaryPayments = (string: string | number,currency:string) => {
    return `${currency} ${string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`
}
